import { axiosInstance } from 'api/apiConfig'
import { setNextPageParam, setNextPageQuery } from 'api/apiUtil'
import { useInfiniteQuery, useMutation, useQuery } from 'react-query'
import { objectToQueryString } from 'utils/object-to-query-string'

//공지사항
// /api/menucrte/carte/v1.0/crtDtlMenuList

const postRequestList = async (target, params) => {
  const { data } = await axiosInstance.post('/api/menucrte/carte/v1.0/' + target, params)
  return data
}

const getRequestList = async (target, params) => {
  const { data } = await axiosInstance.get('/api/menucrte/carte/v1.0/' + target + objectToQueryString(params))
  return data
}

export const useCrtDtlMenuList = (params, isInit) => {
  return useQuery(['crtDtlMenuList'], () => postRequestList('crtDtlMenuList', params), {
    enabled: isInit,
  })
}
export const useCrtDtlRtrv = (params, isInit) => {
  return useQuery(['crtDtlRtrv'], () => postRequestList('crtDtlRtrv', params), {
    enabled: isInit,
  })
}

// 식재 조회
export const useFdingrDtl = (params, isInit) => {
  return useQuery(['fdingrDtl'], () => postRequestList('selectFdingrDtl', params), {
    enabled: isInit,
  })
}

// 주간 식단표 조회
export const useMmMenuLst = (params, isInit) => {
  return useQuery(['crtForm/MmMenuLst', params], () => getRequestList('crtForm/MmMenuLst', params), {
    enabled: isInit,
  })
}

// 조리공정일지 리스트 조회
export const useCokMenuList = (params, isInit) => {
  return useQuery(['crtForm/getCokProcsDiary', params], () => getRequestList('crtForm/getCokProcsDiary', params), {
    enabled: isInit,
  })
}

// 조리공정일지 저장
// /api/menucrte/carte/v1.0/crtForm/savecokprocsdiary
export const useSavecokprocsdiary = ({ successHandler, errorHandler }) => {
  return useMutation((params) => postRequestList('crtForm/savecokprocsdiary', params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}

export const usePurCookMnlbk = (params) => {
  return useQuery(['purCokMnlbk', params], () => postRequestList('purCokMnlbk', params))
}
